import React, { useState, useEffect } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import { Link, useLocation } from "react-router-dom";
import { SidebarData } from "../../core/json/siderbar_data";
import HorizontalSidebar from "./horizontalSidebar";
import CollapsedSidebar from "./collapsedSidebar";
import { useSelector } from "react-redux";

const Sidebar = () => {
  const Location = useLocation();

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const userPermissions = useSelector((state) => state.userpermission);
  const userData = useSelector((state) => state.user_data);

  useEffect(() => {
    if (subOpen || isHovered) {
      document.body.classList.add("expand-menu");
    } else {
      const headerLeft = document.querySelector(".header-left");
      if (!headerLeft || !headerLeft.matches(":hover")) {
        document.body.classList.remove("expand-menu");
      }
    }
    return () => {
      document.body.classList.remove("expand-menu");
    };
  }, [subOpen, isHovered]);

  const toggleSidebar = (title, hasSubmenu) => {
    if (hasSubmenu) {
      if (title == subOpen) {
        setSubopen("");
      } else {
        setSubopen(title);
      }
    } else {
      setSubopen("");
    }
  };

  const toggleSubsidebar = (subitem) => {
    if (subitem == subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const closeSidebar = () => {
    document?.querySelector(".main-wrapper")?.classList?.remove("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.remove("opened");
    document?.querySelector("html")?.classList?.remove("menu-opened");
  };

  const filterSidebarData = (sidebarData, permissions) => {
    if (userData.roleID === 1) {
      return sidebarData; // Admin gets full access
    }

    const permissionKeys = new Set(permissions.map((p) => p.permissionKey)); // Extract permission keys

    return sidebarData
      .map((menu) => {
        const filteredSubmenuItems = menu.submenuItems
          ?.map((submenu) => {
            if (submenu.submenuItems) {
              const filteredSubSubmenu = submenu.submenuItems.filter(
                (subItem) => permissionKeys.has(subItem.link)
              );
              return filteredSubSubmenu.length > 0
                ? { ...submenu, submenuItems: filteredSubSubmenu }
                : null;
            }
            return permissionKeys.has(submenu.link) ? submenu : null;
          })
          .filter(Boolean);

        return filteredSubmenuItems.length > 0
          ? { ...menu, submenuItems: filteredSubmenuItems }
          : null;
      })
      .filter(Boolean);
  };

  const filteredSidebar = filterSidebarData(SidebarData, userPermissions);

  return (
    <div>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                {filteredSidebar?.map((mainLabel, index) => (
                  <li className="submenu-open" key={index}>
                    {/* <h6 className="submenu-hdr">{mainLabel?.label}</h6> */}
                    <ul>
                      {mainLabel?.submenuItems?.map((title, i) => {
                        let link_array = [];
                        title?.submenuItems?.map((link) => {
                          link_array.push(link?.link);
                          if (link?.submenu) {
                            link?.submenuItems?.map((item) => {
                              link_array.push(item?.link);
                            });
                          }
                          return link_array;
                        });
                        title.links = link_array;
                        return (
                          <React.Fragment key={i}>
                            {" "}
                            <li
                              className={`submenu ${
                                !title?.submenu &&
                                Location.pathname === title?.link
                                  ? "custom-active-hassubroute-false"
                                  : ""
                              }`}
                            >
                              <Link
                                to={title?.link}
                                onClick={() => {
                                  toggleSidebar(title?.label, title?.submenu);
                                  if (!title?.submenu) {
                                    closeSidebar();
                                  }
                                }}
                                className={`${
                                  subOpen === title?.label ? "subdrop" : ""
                                } ${
                                  title?.links?.includes(Location.pathname)
                                    ? "active"
                                    : ""
                                }`}
                              >
                                {title?.icon}
                                <span className="custom-active-span">
                                  {title?.label}
                                </span>
                                {title?.submenu && (
                                  <span className="menu-arrow" />
                                )}
                              </Link>
                              <ul
                                style={{
                                  display:
                                    subOpen === title?.label ? "block" : "none",
                                }}
                              >
                                {title?.submenuItems?.map(
                                  (item, titleIndex) => (
                                    <li
                                      className="submenu submenu-two"
                                      key={titleIndex}
                                    >
                                      <Link
                                        to={item?.label === "Business Profile" && userData?.roleID !== 1 ? `${item?.link}/${userData?.businessId}` : item?.link}
                                        className={`${
                                          item?.submenuItems
                                            ?.map((link) => link.link)
                                            .includes(Location.pathname) ||
                                          item?.link === Location.pathname
                                            ? "active"
                                            : ""
                                        } ${
                                          subsidebar === item?.label
                                            ? "subdrop"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          toggleSubsidebar(item?.label);
                                          if (!item?.submenu) {
                                            closeSidebar();
                                            setSubopen("");
                                            setSubsidebar("");
                                          }
                                        }}
                                      >
                                        {item?.label}
                                        {item?.submenu && (
                                          <span className="menu-arrow inside-submenu" />
                                        )}
                                      </Link>
                                      <ul
                                        style={{
                                          display:
                                            subsidebar === item?.label
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        {item?.submenuItems?.map(
                                          (items, subIndex) => (
                                            <li key={subIndex}>
                                              <Link
                                                to={items?.link}
                                                className={`${
                                                  subsidebar === items?.label
                                                    ? "submenu-two subdrop"
                                                    : "submenu-two"
                                                } ${
                                                  items?.submenuItems
                                                    ?.map((link) => link.link)
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                  items?.link ===
                                                    Location.pathname
                                                    ? "active"
                                                    : ""
                                                }`}
                                                onClick={() => {
                                                  closeSidebar();
                                                  setSubopen("");
                                                  setSubsidebar("");
                                                }}
                                              >
                                                {items?.label}
                                              </Link>
                                            </li>
                                          )
                                        )}
                                      </ul>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </React.Fragment>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      <HorizontalSidebar />
      <CollapsedSidebar />
    </div>
  );
};

export default Sidebar;
